<div class="bad-subscription-container">
  <div class="header">
    <img src="../../../assets/img/afas-logo-white.jpg" alt="Automated Family Alert System" />
  </div>

  <h3>Valid Subscription Not Found</h3>
  <p>We're sorry but we could not find a valid subscription for your organization.  Please contact us to remediate the situation!</p>

  <button mat-raised-button color="primary">
    <a routerLink="/contacts" style="color: white;">Go To Dashboard</a>
  </button>

  <button mat-stroked-button>
    <a [href]="contactUsUrl">Contact Us</a>
  </button>
</div>
